<template>
    <div class="main-container">
                <div class="header">
                 
                    <h2 class="contact">Contact Us</h2>
                    <p class="description">Questions or issues with MyCircles?</p>
                </div>
                
                <div class="input-field">
                
                    <div class=" text-left pb-2 disease-input">
            <label for="age" class="mb-1 font-weight-bold"
              >Select Subject</label
            >
            <div class="search-input position-relative ">
              <font-awesome-icon
                size="1x"
                :icon="['fal', 'search']"
                class="position-absolute search-icon"
              />
              <a-select
                show-search
                :default-active-first-option="false"
                :show-arrow="false"
                placeholder="Select Subject"
                class="w-100"
                style="width: 539px"
                v-model="subject"
              >
                <a-select-option
                  :value="c.subject"
                  v-for="(c, index) in subjectList"
                  :key="c"
                  >{{ c.subject }}</a-select-option
                >
              </a-select>
            </div>
        </div>

        <div :style="{display : 'flex','flex-direction':'column'}">

            <label for="textarea" class="mb-1 font-weight-bold"
              >Description</label
            >
            <textarea
            class="textarea1"
            :autofocus="true"
            ref="textarea"
            name=""
            id=""
            cols="60"
            rows="4"
            :maxlength="2000"
            v-model="description"
          ></textarea>
        </div>

        <div>
          <a-button
            class="send-btn"
            :style="{
              backgroundColor:
                !description.trim() || !subject
                  ? 'rgb(226, 232, 240)'
                  : getPrimaryColor(),
              color: !description.trim() || !subject ? '#47556E' : 'white'
            }"
            :disabled="!description.trim() || !subject ? true : false"
            :loading="loading"
            @click="submitFeedBack"
          >
            Send
          </a-button>
        </div>
        
                </div>
    </div>
</template>

<script>

import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const AppRepository = RepositoryFactory.get("app");

export default {
    name : "Support",
    data() {
        return {
            subject : undefined,
            subjectList : [ ],
        description : "",
        loading : false ,
        }
    },
created() {
    this.getSubjects();
},

methods : {
  async getSubjects() {
      AppRepository.getSupportSubject().then((res)=> {
      
        this.subjectList = res.data.data;
      }).catch((err)=> {

      })
 
  },
  submitFeedBack() {
    this.loading = true ;
      const payload = {
        user: this.authUser.user.id,
        role: this.authUser.user.role,
        circle: this.currentCircle.id,
        message: this.description,
        subject: this.subject,
        email : this.authUser.user.email ,
      };
      AppRepository.postFeedBack(payload)
        .then(res => {
          this.loading = false ;
          this.description = "" ;
          this.subject = undefined;
          this.$notification.success({
            message: "Success",
            description: "submitted successfully"
          });
        })
        .catch(err => {
         this.loading = false ;
          this.$notification.success({
            message: "Error",
            description: "Something went wrong while submitting"
          });
        });
    }

}
}

</script>

<style  lang="scss" scoped>

@media screen and (max-width:769px) {
  .input-field {
    width: 100vw !important; 
  }
  .send-btn {
    width:100% !important;
  }
  
}
.main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    .header {
        display: flex;
        flex-direction: column;
        gap:16px;

    .contact {
        font-size :36px ;
        line-height: 46px;
        text-align: center;
        font-weight: 700;
        color :'#1E2945';

    }
    .description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color : "#647490"
    }
    }
}

.search-input {
  display: flex;
  align-items: center;
  position: relative;
}
.search-icon {
  left: 5px;
  font-size: 20px;
  color: #94a3b8;
  z-index: 1;
  margin-left: 12px;
}

.textarea1 {
    outline: none;
    border: 1px solid #CBD5E1;
    border-radius: 8px;
    min-height: 217px;
    padding :16px ;
    &:focus {
      outline: none;
      
    }
  }
.send-btn {
    width:539px;
    padding: 12px 24px;
    border-radius: 6px;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    border: none;
}

.input-field {
  display: flex;
  flex-direction: column;
  gap:24px ;
  padding: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/App/Support.vue